import { render, staticRenderFns } from "./NoficationModal.vue?vue&type=template&id=49b4ac13&scoped=true&"
import script from "./NoficationModal.vue?vue&type=script&lang=js&"
export * from "./NoficationModal.vue?vue&type=script&lang=js&"
import style0 from "./NoficationModal.vue?vue&type=style&index=0&id=49b4ac13&lang=stylus&scoped=true&"
import style1 from "./NoficationModal.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b4ac13",
  null
  
)

export default component.exports